import {State} from "./types";
import {setRequestStatus} from "../request-status";
import {clientInitialState} from "global/initial-states";

export const initialState: State = {
  clients: [],
  clientProducts: [],
  client: clientInitialState,
  pagination: {
    pos: 0,
    lim: 20,
    ser: "",
    hasMore: true,
  },
  clientProductsPagination: {
    pos: 0,
    lim: 50,
    ser: "",
    active: "1",
    clientId: "",
    hasMore: true,
  },
  request: {
    client: setRequestStatus("initial"),
    clients: setRequestStatus("initial"),
    clientProducts: setRequestStatus("initial"),
  },
};
